import {Nullish} from 'shared/web';

interface ResolveQualitySealPatchValueParams {
  currentQualitySealKey: string | Nullish;
  originalQualitySealKey: string | Nullish;
  isQualitySealShown: boolean;
  wasQualitySealChangedByUser: boolean;
  hasSalePresetChanged: boolean;
}

export function resolveQualitySealPatchValue(params: ResolveQualitySealPatchValueParams) {
  if (!params.isQualitySealShown) {
    return undefined;
  }

  const currentQualitySealKey = params.currentQualitySealKey ?? null;
  const originalQualitySealKey = params.originalQualitySealKey ?? null;

  if (params.wasQualitySealChangedByUser) {
    return currentQualitySealKey;
  }

  if (params.hasSalePresetChanged) {
    return undefined;
  }

  return currentQualitySealKey === originalQualitySealKey ? undefined : currentQualitySealKey;
}
